module.exports = __webpack_public_path__ + "media/images/expert__selectedArrow--dark-151d7ff7d182a7a52be352ac8ec334ca.png";